var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.crossitem
    ? _c(
        "div",
        [
          _c("div", { attrs: { id: "addons-modal-wrapper" } }, [
            _c(
              "div",
              {
                ref: "addonsModal",
                staticClass: "modal fade addons-modal",
                class: [{ show: _vm.addonModal == true }],
                attrs: {
                  id: "addons" + _vm.secondlist,
                  tabindex: "-1",
                  role: "dialog"
                }
              },
              [
                _vm.modalItem && _vm.modalItem.data
                  ? _c("div", { staticClass: "modal-dialog" }, [
                      _c(
                        "div",
                        {
                          staticClass: "modal-content",
                          staticStyle: {
                            width: "75%!important",
                            left: "50%",
                            transform: "translate(-50%, 10px)"
                          }
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            _c("div", { staticClass: "modal-title h3" }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("itemNameVariation")(
                                    _vm.modalItem.data
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "close",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal",
                                  "aria-hidden": "true"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.closeModal()
                                  }
                                }
                              },
                              [_vm._v("×")]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-body p-4" }, [
                            _c("div", [
                              _c(
                                "ul",
                                { staticClass: "list-unstyled single-list" },
                                [
                                  _c("li", [
                                    _c(
                                      "div",
                                      { staticClass: "d-flex border-bottom" },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "w-50 font-weight-bold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemNumber"
                                                )
                                              )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.modalItem.data.variation
                                                .number
                                            )
                                          )
                                        ])
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(
                                    _vm.modalItem.data.variationProperties,
                                    function(prop) {
                                      return [
                                        prop.property.id != 9 &&
                                        prop.property.id != 76 &&
                                        prop.property.id != 39 &&
                                        prop.property.id != 86 &&
                                        prop.property.id != 84 &&
                                        (prop.property.id != 18) &
                                          (prop.property.id != 106) &
                                          (prop.property.id != 341) &&
                                        prop.property.id != 421 &&
                                        prop.property.id != 418 &&
                                        prop.property.id != 419 &&
                                        prop.property.id != 434 &&
                                        prop.values.value != "" &&
                                        prop.property.display.includes(
                                          "showOnItemsPage"
                                        )
                                          ? _c("li", [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex border-bottom"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "w-50 font-weight-bold"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          prop.property.names
                                                            .name
                                                        )
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  prop.property.id != 423 &&
                                                  prop.property.id != 424 &&
                                                  prop.property.id != 425 &&
                                                  prop.property.id != 426 &&
                                                  prop.property.id != 188 &&
                                                  prop.property.id !== 405 &&
                                                  prop.property.id !== 463
                                                    ? _c(
                                                        "span",
                                                        [
                                                          prop.property.cast ==
                                                          "multiSelection"
                                                            ? [
                                                                prop.property
                                                                  .id == 433 ||
                                                                prop.property
                                                                  .id == 427 ||
                                                                prop.property
                                                                  .id == 428
                                                                  ? [
                                                                      _vm._l(
                                                                        prop.values,
                                                                        function(
                                                                          multi
                                                                        ) {
                                                                          return [
                                                                            (multi.value !==
                                                                              "Ja" &&
                                                                              multi.value !==
                                                                                "ja" &&
                                                                              multi.value !==
                                                                                "Yes" &&
                                                                              multi.value !==
                                                                                "yes") ||
                                                                            prop
                                                                              .values
                                                                              .length <
                                                                              2
                                                                              ? [
                                                                                  prop
                                                                                    .property
                                                                                    .id ==
                                                                                  433
                                                                                    ? [
                                                                                        _vm._v(
                                                                                          "\n                                                  " +
                                                                                            _vm._s(
                                                                                              multi.value
                                                                                            ) +
                                                                                            " x\n                                            "
                                                                                        )
                                                                                      ]
                                                                                    : [
                                                                                        _vm._v(
                                                                                          "\n                                                  " +
                                                                                            _vm._s(
                                                                                              multi.value
                                                                                            ) +
                                                                                            "\n                                            "
                                                                                        )
                                                                                      ]
                                                                                ]
                                                                              : _vm._e()
                                                                          ]
                                                                        }
                                                                      )
                                                                    ]
                                                                  : _vm._l(
                                                                      prop.values,
                                                                      function(
                                                                        multi
                                                                      ) {
                                                                        return [
                                                                          _vm._v(
                                                                            "\n                               - " +
                                                                              _vm._s(
                                                                                multi.value
                                                                              ) +
                                                                              "  "
                                                                          ),
                                                                          _c(
                                                                            "br"
                                                                          )
                                                                        ]
                                                                      }
                                                                    )
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          [
                                                            _vm._v(
                                                              "\n                           " +
                                                                _vm._s(
                                                                  prop.values
                                                                    .value
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        ],
                                                        2
                                                      )
                                                    : prop.property.id == 463
                                                    ? _c(
                                                        "span",
                                                        [
                                                          prop.values.value >=
                                                          100
                                                            ? [
                                                                _vm._v(
                                                                  "\n                             " +
                                                                    _vm._s(
                                                                      prop
                                                                        .values
                                                                        .value /
                                                                        100
                                                                    ) +
                                                                    " m\n                          "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                              " +
                                                                    _vm._s(
                                                                      prop
                                                                        .values
                                                                        .value
                                                                    ) +
                                                                    " cm\n                          "
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    : prop.property.id !== 405
                                                    ? _c(
                                                        "span",
                                                        [
                                                          prop.values.value >=
                                                          100
                                                            ? [
                                                                _vm._v(
                                                                  "\n                           " +
                                                                    _vm._s(
                                                                      prop
                                                                        .values
                                                                        .value /
                                                                        100
                                                                    ) +
                                                                    "  m\n                        "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                            " +
                                                                    _vm._s(
                                                                      prop
                                                                        .values
                                                                        .value
                                                                    ) +
                                                                    "  cm\n                        "
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    : prop.property.id == 405
                                                    ? _c(
                                                        "span",
                                                        [
                                                          prop.values.value >=
                                                          1000
                                                            ? [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      prop
                                                                        .values
                                                                        .value /
                                                                        1000
                                                                    ) +
                                                                    "  kg\n                      "
                                                                )
                                                              ]
                                                            : [
                                                                _vm._v(
                                                                  "\n                         " +
                                                                    _vm._s(
                                                                      prop
                                                                        .values
                                                                        .value
                                                                    ) +
                                                                    "  g\n                      "
                                                                )
                                                              ]
                                                        ],
                                                        2
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  )
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "text-center mt-4 mb-4" },
                              [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    loading: "lazy",
                                    src: _vm._f("itemImage")(
                                      _vm._f("itemImages")(
                                        _vm.modalItem.data.images,
                                        "urlPreview"
                                      )
                                    ),
                                    alt: _vm._f("itemNameVariation")(
                                      _vm.modalItem.data
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "d-flex justify-content-between" },
                              [
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "button",
                                        "data-dismiss": "modal",
                                        "aria-hidden": "true"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.redirectToItem(
                                            _vm.modalItem
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Zum Artikel\n                "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-primary",
                                      attrs: {
                                        type: "button",
                                        "data-dismiss": "modal",
                                        "aria-hidden": "true"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.closeModal()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Schließen\n                "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]),
          _vm._v(" "),
          _vm.secondlist != "true"
            ? _c("div", { staticClass: "crosslist" }, [
                _c("div", { staticClass: "h3 mb-3" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Woerner::Template.addonItemsHeadline")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "list-unstyled single-crosslist" },
                  _vm._l(_vm.crossitem.slice(0, 4), function(item, index) {
                    return _c(
                      "li",
                      {
                        staticClass: "mb-1 crosslistitem",
                        attrs: { "data-variation-id": item.data.variation.id }
                      },
                      [
                        _c("input", {
                          staticClass: "d-none",
                          attrs: { type: "text" },
                          domProps: { value: item.data.variation.id }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "mr-3 d-none",
                          attrs: {
                            type: "checkbox",
                            id: "var_" + item.data.variation.id
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass:
                              "cursor d-flex align-items-center mb-0",
                            attrs: { for: "var_" + item.data.variation.id }
                          },
                          [
                            _c("div", { staticClass: "d-flex" }, [
                              _c("div", { staticClass: "mr-3" }, [
                                _c("img", {
                                  staticClass: "img-fluid",
                                  attrs: {
                                    loading: "lazy",
                                    src: _vm._f("itemImage")(
                                      _vm._f("itemImages")(
                                        item.data.images,
                                        "urlPreview"
                                      )
                                    ),
                                    alt: item.data.texts.name1
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex-fill" }, [
                                _c("div", { staticClass: "crosslisttitle" }, [
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("itemNameVariation")(item.data)
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "crosslistadditional" },
                                  [
                                    _c("div", { staticClass: "d-flex" }, [
                                      _c("div", [
                                        _vm._v(
                                          "\n                    +" +
                                            _vm._s(
                                              item.data.prices.default.price
                                                .formatted
                                            ) +
                                            "\n                    "
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass: "vat small text-muted"
                                          },
                                          [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.$translate(
                                                    "Ceres::Template.singleItemInclVAT"
                                                  )
                                                ) +
                                                ")\n                  "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-fill justify-content-end pr-1"
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      "data-toggle": "modal",
                                      href: "#addons" + _vm.secondlist
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.setModal(item)
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-info-circle",
                                      staticStyle: {
                                        "font-size": "20px",
                                        padding: "7px"
                                      },
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.crossitem.length > 4
                  ? _c(
                      "div",
                      {
                        staticClass: "mb-3 mt-1 h5",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#28a745!important" },
                            attrs: { href: "#extraCrossList" }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: { "text-decoration": "underline" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Woerner::Template.singleCrossExtraLink"
                                      )
                                    )
                                )
                              ]
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            : _vm.crossitem.length > 4
            ? [
                _c(
                  "div",
                  {
                    staticClass: "widget-accordion widget-primary",
                    attrs: { id: "accordion_5" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card", attrs: { id: "extraCrossList" } },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "card-header btn btn-link text-appearance",
                            attrs: {
                              id: "heading_5_5",
                              type: "button",
                              "data-toggle": "collapse",
                              "data-target": "#collapse_5_5",
                              "aria-expanded": "true",
                              "aria-controls": "collapse_5_5",
                              "aria-label": "Toggle replacement parts"
                            }
                          },
                          [
                            _c("div", { staticClass: "h5 pr-5 mb-0" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Woerner::Template.singleCrossTitle"
                                    )
                                  ) +
                                  "\n            "
                              ),
                              _c("i", {
                                staticClass: "fa fa-angle-down centered-angle"
                              })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "collapse show",
                            attrs: {
                              id: "collapse_5_5",
                              "aria-labelledby": "heading_5_5",
                              "data-parent": "#accordion_5"
                            }
                          },
                          [
                            _c("div", { staticClass: "card-body px-0" }, [
                              _c("div", { staticClass: "crosslist" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "row list-unstyled single-crosslist"
                                  },
                                  _vm._l(_vm.crossitem.slice(4), function(
                                    item
                                  ) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass:
                                          "mb-1 col-lg-6 col-12 crosslistitem",
                                        attrs: {
                                          "data-variation-id":
                                            item.data.variation.id
                                        }
                                      },
                                      [
                                        _c("input", {
                                          staticClass: "d-none",
                                          attrs: { type: "text" },
                                          domProps: {
                                            value: item.data.variation.id
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          staticClass: "mr-3 d-none",
                                          attrs: {
                                            type: "checkbox",
                                            id: "var_" + item.data.variation.id
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "cursor d-flex align-items-center mb-0",
                                            attrs: {
                                              for:
                                                "var_" + item.data.variation.id
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "mr-3" },
                                                  [
                                                    _c("img", {
                                                      staticClass: "img-fluid",
                                                      attrs: {
                                                        loading: "lazy",
                                                        src:
                                                          "item.data.images | itemImages('urlPreview') | itemImage",
                                                        alt:
                                                          item.data.texts.name1
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "flex-fill" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "crosslisttitle"
                                                      },
                                                      [
                                                        _c("b", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm._f(
                                                                "itemNameVariation"
                                                              )(item.data)
                                                            )
                                                          )
                                                        ])
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "crosslistadditional"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex"
                                                          },
                                                          [
                                                            _c("div", [
                                                              _vm._v(
                                                                "\n                              +" +
                                                                  _vm._s(
                                                                    item.data
                                                                      .prices
                                                                      .default
                                                                      .price
                                                                      .formatted
                                                                  ) +
                                                                  "\n                              "
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "vat small text-muted"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                  (" +
                                                                      _vm._s(
                                                                        _vm.$translate(
                                                                          "Ceres::Template.singleItemInclVAT"
                                                                        )
                                                                      ) +
                                                                      ")\n                  "
                                                                  )
                                                                ]
                                                              )
                                                            ])
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex flex-fill justify-content-end pr-1"
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      "data-toggle": "modal",
                                                      href:
                                                        "#addons" +
                                                        _vm.secondlist
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setModal(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fa fa-info-circle",
                                                      staticStyle: {
                                                        "font-size": "20px",
                                                        padding: "7px"
                                                      },
                                                      attrs: {
                                                        "aria-hidden": "true"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  }),
                                  0
                                )
                              ])
                            ])
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            : _vm._e()
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }